export default "__VITE_ASSET__c7fcb16c__"